var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pad-header-container"},[_c('div',{staticClass:"pad-header-operate"},[(_vm.IsHome)?void 0:[_c('div',{staticClass:"pad-header-module-back",on:{"click":_vm.back}},[_c('i',{staticClass:"fa fa-angle-left fa-lg"})])]],2),_c('div',{staticClass:"pad-header-title"},[_c('span',[_vm._v(_vm._s(_vm.Title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }